module.exports = __webpack_public_path__ + "static/img/cloudManage.10af3cbb.png";